export const CLASS_FULL = "md:col-span-5 lg:col-[_span_20/_span_20] w-full";
export const CLASS_XXXXXXEXTRA_LARGE = "md:col-span-5 lg:col-span-10 w-full";
export const CLASS_XXXXXEXTRA_LARGE = "md:col-span-5 lg:col-span-9 w-full";
export const CLASS_XXXXEXTRA_LARGE = "md:col-span-5 lg:col-span-8 w-full";
export const CLASS_XXXEXTRA_LARGE = "md:col-span-5 lg:col-span-7 w-full";
export const CLASS_XXEXTRA_LARGE = "md:col-span-5 lg:col-span-6 w-full";
export const CLASS_XEXTRA_LARGE = "md:col-span-5 lg:col-span-5 w-full";
export const CLASS_EXTRA_LARGE = "md:col-span-5 lg:col-span-4 w-full";
export const CLASS_LARGE = "md:col-span-5 lg:col-span-3 w-full";
export const CLASS_MEDIUM = "md:col-span-5 lg:col-span-2 w-full";
export const CLASS_SMALL = "md:col-span-5 lg:col-span-1 w-full";
export const CLASS_CHECKBOX = "p-3 custom_checkbox";
